import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, normalizeStyle as _normalizeStyle, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5d8f3014")
const _hoisted_1 = { class: "persons-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "persons"
}
const _hoisted_3 = { class: "persons__group" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "persons__person__photo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "persons__person__name" }
const _hoisted_8 = {
  key: 0,
  class: "persons__person__birth-year"
}
const _hoisted_9 = {
  key: 1,
  class: "person"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "person__photo__edit"
}
const _hoisted_12 = { class: "person__name" }
const _hoisted_13 = {
  key: 0,
  class: "person__birth-date"
}
const _hoisted_14 = { class: "person__tab-bar" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Foto's ")
const _hoisted_16 = { class: "badge" }
const _hoisted_17 = { class: "person__tab" }
const _hoisted_18 = { style: {"display":"grid","grid-template-columns":"1fr 1fr","column-gap":"16px","row-gap":"16px"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Algemeen", -1)
const _hoisted_20 = {
  class: "field",
  style: {"grid-column":"span 2"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Geslacht", -1)
const _hoisted_22 = { class: "radios" }
const _hoisted_23 = { class: "radio" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Man ")
const _hoisted_25 = { class: "radio" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Vrouw ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Naam", -1)
const _hoisted_28 = { class: "field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "firstNames" }, [
  /*#__PURE__*/_createTextVNode("Voornamen "),
  /*#__PURE__*/_createElementVNode("em", null, "(inclusief doopnamen)")
], -1)
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "nickname" }, "Roepnaam", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Achternaam", -1)
const _hoisted_33 = {
  key: 0,
  class: "field"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "maidenName" }, "Meisjesnaam", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Datums", -1)
const _hoisted_36 = { class: "field" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "bornAt" }, [
  /*#__PURE__*/_createTextVNode("Geboren op "),
  /*#__PURE__*/_createElementVNode("em", null, "(DD-MM-YYYY)")
], -1)
const _hoisted_38 = { class: "field" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "bornIn" }, [
  /*#__PURE__*/_createTextVNode("Geboren in "),
  /*#__PURE__*/_createElementVNode("em", null, "(plaatsnaam)")
], -1)
const _hoisted_40 = { class: "field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "diedAt" }, [
  /*#__PURE__*/_createTextVNode("Overleden op "),
  /*#__PURE__*/_createElementVNode("em", null, "(DD-MM-YYYY)")
], -1)
const _hoisted_42 = { class: "field" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "diedIn" }, [
  /*#__PURE__*/_createTextVNode("Overleden in "),
  /*#__PURE__*/_createElementVNode("em", null, "(plaatsnaam)")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Ouders", -1)
const _hoisted_45 = { class: "field" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "father" }, "Vader", -1)
const _hoisted_47 = { class: "persons__person__photo" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "parent__name" }
const _hoisted_50 = { class: "field" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "mother" }, "Moeder", -1)
const _hoisted_52 = { class: "persons__person__photo" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "parent__name" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Overige", -1)
const _hoisted_56 = {
  class: "field",
  style: {"grid-column":"span 2"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "remarks" }, "Opmerkingen", -1)
const _hoisted_58 = { style: {"display":"flex","align-items":"center","grid-column":"span 2"} }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button is-green"
}, "Opslaan", -1)
const _hoisted_60 = { style: {"margin-left":"16px"} }
const _hoisted_61 = { class: "person__tab" }
const _hoisted_62 = {
  class: "objects",
  style: {"columns":"2"}
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_layout_default = _resolveComponent("v-layout-default")!
  const _component_v_add_person_dialog = _resolveComponent("v-add-person-dialog")!
  const _component_v_set_person_picture = _resolveComponent("v-set-person-picture")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_layout_default, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (family) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["persons__group__heading", { 'is-unknown': family.lastName === ' ' }])
                    }, _toDisplayString(family.lastName === ' ' ? 'achternaam onbekend' : family.lastName), 3),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(family.persons, (person) => {
                      return (_openBlock(), _createElementBlock("button", {
                        class: _normalizeClass(["persons__person", { 'is-active': _ctx.activePerson && _ctx.activePerson.id === person.id }]),
                        onClick: _withModifiers(($event: any) => (_ctx.activePersonId = person.id), ["prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          (person.picture)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.getPictureForPerson(person)
                              }, null, 8, _hoisted_6))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(person.nickname || person.firstNames), 1),
                        (person.bornAt && person.bornAt.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getBirthYear(person.bornAt)), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_4))
                    }), 256))
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_ctx.activePerson)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["person__photo", { 'is-empty': !(_ctx.activePerson.photos.length > 0 && (_ctx.activePerson.picture ? _ctx.activePerson.photos.length > 1 : true)) }]),
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ((_ctx.activePerson.photos.length > 0 && (_ctx.activePerson.picture ? _ctx.activePerson.photos.length > 1 : true)) ? _ctx.flags.setPicture = true : ''), ["prevent"]))
                }, [
                  (_ctx.activePerson.picture)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getPictureForPerson(_ctx.activePerson)
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_ctx.activePerson.photos.length > 0 && (_ctx.activePerson.picture ? _ctx.activePerson.photos.length > 1 : true))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "wijzigen"))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.activePerson.nickname || _ctx.activePerson.firstNames) + " " + _toDisplayString(_ctx.activePerson.lastName) + _toDisplayString(_ctx.activePerson.maidenName && _ctx.activePerson.maidenName.length > 0 ? `-${_ctx.activePerson.maidenName}` : ''), 1),
                (_ctx.activePerson.bornAt && _ctx.activePerson.bornAt.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.showDate(_ctx.activePerson.bornAt)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("nav", _hoisted_14, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["person__tab-bar__tab", { 'is-active': _ctx.activeTab === 'data' }]),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.activeTab = 'data'), ["prevent"]))
                  }, "Gegevens", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["person__tab-bar__tab", { 'is-active': _ctx.activeTab === 'photos' }]),
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.activeTab = 'photos'), ["prevent"]))
                  }, [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.activePerson.photos.length), 1)
                  ], 2)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                  _createElementVNode("form", {
                    novalidate: "",
                    autocomplete: "off",
                    onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "gender",
                              value: "MALE",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fields.gender = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.fields.gender]
                            ]),
                            _hoisted_24
                          ]),
                          _createElementVNode("label", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "gender",
                              value: "FEMALE",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fields.gender = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.fields.gender]
                            ]),
                            _hoisted_26
                          ])
                        ])
                      ]),
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "firstNames",
                          type: "text",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fields.firstNames = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.firstNames]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "nickname",
                          type: "text",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.fields.nickname = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.nickname]
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "field",
                        style: _normalizeStyle(`grid-column: span ${_ctx.fields.gender === 'FEMALE' ? '1' : '2'}`)
                      }, [
                        _hoisted_32,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "lastName",
                          type: "text",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.fields.lastName = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.lastName]
                        ])
                      ], 4),
                      (_ctx.fields.gender === 'FEMALE')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _hoisted_34,
                            _withDirectives(_createElementVNode("input", {
                              class: "control",
                              id: "maidenName",
                              type: "text",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fields.maidenName = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.fields.maidenName]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "bornAt",
                          type: "text",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.fields.bornAt = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.bornAt]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "bornIn",
                          type: "text",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.fields.bornIn = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.bornIn]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "diedAt",
                          type: "text",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.fields.diedAt = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.diedAt]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "diedIn",
                          type: "text",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.fields.diedIn = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.diedIn]
                        ])
                      ]),
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("button", {
                          type: "button",
                          class: "control is-parent-button",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => {_ctx.flags.isParentSearching = true; _ctx.flags.parentSearch.father = true;}, ["prevent"]))
                        }, [
                          (_ctx.fields.fatherId)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_47, [
                                  (_ctx.activePersonFather.picture)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.getPictureForPerson(_ctx.activePersonFather)
                                      }, null, 8, _hoisted_48))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.getPersonName(_ctx.fields.fatherId)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("button", {
                          type: "button",
                          class: "control is-parent-button",
                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => {_ctx.flags.isParentSearching = true; _ctx.flags.parentSearch.mother = true;}, ["prevent"]))
                        }, [
                          (_ctx.fields.motherId && _ctx.activePersonMother)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_52, [
                                  (_ctx.activePersonMother.picture)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.getPictureForPerson(_ctx.activePersonMother)
                                      }, null, 8, _hoisted_53))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.getPersonName(_ctx.fields.motherId)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _hoisted_55,
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "control",
                          id: "remarks",
                          style: {"width":"100%","min-height":"200px"},
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.fields.remarks = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.remarks]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("span", _hoisted_60, "Opgeslagen", 512), [
                              [_vShow, _ctx.personSaved]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 32)
                ], 512), [
                  [_vShow, _ctx.activeTab === 'data']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePerson.photos, (object) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: { name: 'object', params: { objectId: object.id } },
                        style: {"display":"block","width":"100%","margin":"16px"},
                        class: "objects__object"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            style: _normalizeStyle([{"display":"inline-block","width":"100%","background-size":"cover"}, {
                    'background-image': `url(${_ctx.getUrlForFile(object.files[0])})`,
                    'padding-bottom': `${_ctx.getRatioForFile(object.files[0])}%`,
                  }])
                          }, null, 4)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 256))
                  ])
                ], 512), [
                  [_vShow, _ctx.activeTab === 'photos']
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.flags.isParentSearching)
      ? (_openBlock(), _createBlock(_component_v_add_person_dialog, {
          key: 0,
          exclude: _ctx.activePersonId,
          excludeGender: _ctx.flags.parentSearch.father ? 'FEMALE' : 'MALE',
          onFound: _ctx.onParentFound,
          onCancel: _cache[17] || (_cache[17] = ($event: any) => {_ctx.flags.isParentSearching = false; _ctx.flags.parentSearch.father = false; _ctx.flags.parentSearch.mother = false;})
        }, null, 8, ["exclude", "excludeGender", "onFound"]))
      : _createCommentVNode("", true),
    (_ctx.activePerson && _ctx.flags.setPicture)
      ? (_openBlock(), _createBlock(_component_v_set_person_picture, {
          key: 1,
          person: _ctx.activePerson,
          onDone: _ctx.onPictureSet,
          onCancel: _cache[18] || (_cache[18] = ($event: any) => (_ctx.flags.setPicture = false))
        }, null, 8, ["person", "onDone"]))
      : _createCommentVNode("", true)
  ], 64))
}